<template>
    <div class="portal-tab-div profile">
        <tostWindow :message="toastMessage" v-if="showT" />
        <div class="portal-profile-box acctmgmt">
            <!-- Account Management Section -->
            <div class="text-block-925">Manage Account<br></div>
            <div class="text-block-926">Update Contact Information<br></div>
            <div class="form-block-14 w-form">
                <form id="email-form" name="email-form" data-name="Email Form" method="get" class="form-15" @submit.prevent="updateDetails">
                    <!-- Name Fields -->
                    <div class="portal-form-2-input-div">
                        <div class="input-div-half">
                            <label for="First-Name" class="field-label-2">First Name</label>
                            <input class="portal-input w-input" 
                                maxlength="256" 
                                name="First-Name" 
                                data-name="First Name" 
                                placeholder="" 
                                type="text" 
                                id="First-Name" 
                                v-model="profileUser.first_name"
                                required>
                        </div>
                        <div class="input-div-half">
                            <label for="Last-Name" class="field-label-2">Last Name</label>
                            <input class="portal-input w-input" 
                                maxlength="256" 
                                name="Last-Name" 
                                data-name="Last Name" 
                                placeholder="" 
                                type="text" 
                                id="Last-Name" 
                                v-model="profileUser.last_name"
                                required>
                        </div>
                    </div>
                    
                    <!-- Email and Phone Fields -->
                    <div class="portal-form-2-input-div">
                        <div class="input-div-half">
                            <label for="Email" class="field-label-2">Email</label>
                            <input class="portal-input w-input" 
                                maxlength="256" 
                                name="Email" 
                                data-name="Email" 
                                placeholder="" 
                                type="email" 
                                id="Email" 
                                v-model="profileUser.email"
                                required>
                        </div>
                        <div class="input-div-half">
                            <label for="Phone" class="field-label-2">Phone Number</label>
                            <div class="phone-entry-div felix">
                                <input class="phone-number-field-3 _1 form w-input" 
                                    maxlength="3" 
                                    name="field-2" 
                                    data-name="Field 2" 
                                    placeholder="(000)" 
                                    type="text" 
                                    id="field-2" 
                                    v-model="phonePartOne"
                                    @input="updatePhone"
                                    required>
                                <div class="text-block-1417">-</div>
                                <input class="phone-number-field-3 form w-input" 
                                    maxlength="3" 
                                    name="field-2" 
                                    data-name="Field 2" 
                                    placeholder="000" 
                                    type="text" 
                                    id="field-2" 
                                    v-model="phonePartTwo"
                                    @input="updatePhone"
                                    required>
                                <div class="text-block-1417">-</div>
                                <input class="phone-number-field-3 _2 form w-input" 
                                    maxlength="4" 
                                    name="field-2" 
                                    data-name="Field 2" 
                                    placeholder="0000" 
                                    type="text" 
                                    id="field-2" 
                                    v-model="phonePartThree"
                                    @input="updatePhone"
                                    required>
                            </div>
                            <label class="w-checkbox">
                                <input type="checkbox" 
                                    name="checkbox-2" 
                                    id="checkbox-2" 
                                    data-name="Checkbox 2" 
                                    class="w-checkbox-input"
                                    v-model="profileUser.text_updates">
                                <span class="checkbox-label-20 w-form-label" for="checkbox-2">Text me with news and offers</span>
                            </label>
                        </div>
                    </div>
                    
                    
                    
                    <input type="submit" 
                        data-wait="Please wait..." 
                        class="submit-button-14 w-button" 
                        value="Update">
                </form>
                <div class="w-form-done" v-if="showSuccessMessage">
                    <div>Thank you! Your submission has been received!</div>
                </div>
                <div class="w-form-fail" v-if="showErrorMessage">
                    <div>{{errorMessage}}</div>
                </div>
            </div>
            
            <!-- Physical Information Section -->
            <div class="text-block-926">Update Physical Information<br></div>
            <div class="form-block-14 w-form">
                <form id="physical-form" name="email-form" data-name="Email Form" method="get" class="form-15" @submit.prevent="updatePhysicalInfo">
                    <div class="text-block-937">Gender at Birth</div>
                    <div class="div-block-1849">
                        <label class="w-radio">
                            <input type="radio" 
                                name="radio" 
                                id="radio-male" 
                                data-name="Radio" 
                                class="w-form-formradioinput w-radio-input" 
                                value="Male"
                                v-model="profileUser.gender">
                            <span class="radio-button-label-2 w-form-label" for="radio-male">Male</span>
                        </label>
                        <label class="w-radio">
                            <input type="radio" 
                                name="radio" 
                                id="radio-female" 
                                data-name="Radio" 
                                class="w-form-formradioinput w-radio-input" 
                                value="Female"
                                v-model="profileUser.gender">
                            <span class="radio-button-label-2 w-form-label" for="radio-female">Female</span>
                        </label>
                    </div>
                    
                    <div class="field-label-2">Height in Feet &amp; Inches</div>
                    <div class="portal-form-2-input-div">
                        <div class="input-div-half">
                            <input class="portal-input w-input" 
                                maxlength="256" 
                                name="height-feet" 
                                data-name="Height Feet" 
                                placeholder="Feet" 
                                type="text" 
                                id="height-feet" 
                                v-model.number="heightFeet"
                                @input="updateHeight"
                                required>
                        </div>
                        <div class="input-div-half">
                            <input class="portal-input w-input" 
                                maxlength="256" 
                                name="height-inches" 
                                data-name="Height Inches" 
                                placeholder="Inches" 
                                type="text" 
                                id="height-inches" 
                                v-model.number="heightInches"
                                @input="updateHeight"
                                required>
                        </div>
                    </div>
                    
                    <div class="portal-form-2-input-div">
                        <div class="input-div-half">
                            <label for="Weight" class="field-label-2">Weight in Pounds (Lbs.)</label>
                            <input class="portal-input w-input" 
                                maxlength="256" 
                                name="Weight" 
                                data-name="Weight" 
                                placeholder="" 
                                type="text" 
                                id="Weight" 
                                v-model.number="profileUser.weight"
                                required>
                        </div>
                    </div>
                    
                    <input type="submit" 
                        data-wait="Please wait..." 
                        class="submit-button-14 w-button" 
                        value="Update">
                </form>
                <div class="w-form-done" v-if="showPhysicalInfoSuccess">
                    <div>Thank you! Your submission has been received!</div>
                </div>
                <div class="w-form-fail" v-if="showPhysicalInfoError">
                    <div>{{physicalInfoErrorMessage}}</div>
                </div>
            </div>
            
            <!-- Shipping Address Section -->
            <div class="text-block-926">Update Shipping Address<br></div>
            <div class="w-form">
                <form id="address-form" name="email-form" data-name="Email Form" method="get" class="form-15" @submit.prevent="updateAddress">
                    <div class="portal-form-2-input-div address">
                        <div class="input-div-half shipping">
                            <label for="Address" class="field-label-2">Address</label>
                            <input class="portal-input w-input" 
                                maxlength="256" 
                                name="Address" 
                                data-name="Address" 
                                placeholder="" 
                                type="text" 
                                id="Address" 
                                v-model="addressForm.address_line_1"
                                required>
                        </div>
                        <div class="input-div-half apt">
                            <label for="Apt" class="field-label-2">Apt. #</label>
                            <input class="portal-input w-input" 
                                maxlength="256" 
                                name="Apt" 
                                data-name="Apt" 
                                placeholder="" 
                                type="text" 
                                id="Apt" 
                                v-model="addressForm.address_line_2">
                        </div>
                    </div>
                    
                    <!-- City, State, Zip -->
                    <div class="portal-form-2-input-div">
                        <div class="input-div-half">
                            <label for="City" class="field-label-2">City</label>
                            <input class="portal-input w-input" 
                                maxlength="256" 
                                name="City" 
                                data-name="City" 
                                placeholder="" 
                                type="text" 
                                id="City" 
                                v-model="addressForm.city"
                                required>
                        </div>
                        <div class="input-div-half">
                            <label for="State" class="field-label-2">State</label>
                            <select v-model="addressForm.state" required class="select-field-7 form w-select">
                                    <option value="" disabled selected>State...</option>
                                    <option v-for="(value, key) in allstate" :key="key" :value="value">{{ key }}
                                    </option>
                                </select>

                        </div>
                    </div>
                    
                    <div class="portal-form-2-input-div">
                        <div class="input-div-half">
                            <label for="Zip" class="field-label-2">Zip Code</label>
                            <input class="portal-input w-input" 
                                maxlength="10" 
                                name="Zip" 
                                data-name="Zip" 
                                placeholder="" 
                                type="text" 
                                id="Zip" 
                                v-model="addressForm.zip"
                                required>
                        </div>
                    </div>
                    
                    <input type="submit" 
                        data-wait="Please wait..." 
                        class="submit-button-14 w-button" 
                        value="Update">
                </form>
                <div class="w-form-done" v-if="showAddressSuccess">
                    <div>Thank you! Your submission has been received!</div>
                </div>
                <div class="w-form-fail" v-if="showAddressError">
                    <div>{{addressErrorMessage}}</div>
                </div>
            </div>
            
            <!-- Password Update Section -->
            <div class="text-block-926">Update Password<br></div>
            <div class="w-form">
                <form id="password-form" name="email-form" data-name="Email Form" method="get" class="form-15" @submit.prevent="updatePassword">
                    <div class="portal-form-2-input-div">
                        <div class="input-div-half">
                            <label for="New-Password" class="field-label-2">New Password</label>
                            <input class="portal-input w-input" 
                                maxlength="256" 
                                name="New-Password-2" 
                                data-name="New Password 2" 
                                placeholder="" 
                                type="password" 
                                id="New-Password-2" 
                                v-model="passwordForm.newPassword"
                                required>
                        </div>
                    </div>
                    <div class="portal-form-2-input-div">
                        <div class="input-div-half">
                            <label for="Confirm-Password" class="field-label-2">Confirm New Password</label>
                            <input class="portal-input w-input" 
                                maxlength="256" 
                                name="Confirm-Password" 
                                data-name="Confirm Password" 
                                placeholder="" 
                                type="password" 
                                id="Confirm-Password" 
                                v-model="passwordForm.confirmPassword"
                                required>
                        </div>
                    </div>
                    <input type="submit" 
                        data-wait="Please wait..." 
                        class="submit-button-14 w-button" 
                        value="Update">
                </form>
                <div class="w-form-done" v-if="showPasswordSuccess">
                    <div>Thank you! Your submission has been received!</div>
                </div>
                <div class="w-form-fail" v-if="showPasswordError">
                    <div>{{passwordErrorMessage}}</div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import state from "@/utils/state.json"
import tostWindow from './tostWindow.vue'

export default {
    name: 'ProfileSection',
    components: {
        tostWindow
    },
    props: {
        baseUrl: {
            type: String,
            required: true
        },
        user: {
            type: Object,
            required: true
        },
    },
    data() {
        return {
            allstate: state,
            updating: false,
            showSuccessMessage: false,
            showErrorMessage: false,
            showPhysicalInfoSuccess: false,
            showPhysicalInfoError: false,
            showAddressSuccess: false,
            showAddressError: false,
            showPasswordSuccess: false,
            showPasswordError: false,
            showT: false,
            toastMessage: '',
            errorMessage: '',
            physicalInfoErrorMessage: '',
            addressErrorMessage: '',
            passwordErrorMessage: '',
            profileUser: {
                first_name: '',
                last_name: '',
                email: '',
                phone: '',
                gender: '',
                weight: '',
                height_inch: 0,
                text_updates: false,
                preferred_categories: []
            },
            phonePartOne: '',
            phonePartTwo: '',
            phonePartThree: '',
            heightFeet: 0,
            heightInches: 0,
            categories: ['MIND', 'BODY', 'WEIGHT', 'SEX', 'LONGEVITY', 'SKIN', 'HAIR'],
            passwordForm: {
                oldPassword: '',
                newPassword: '',
                confirmPassword: ''
            },
            addressForm: {
                address_line_1: '',
                address_line_2: '',
                city: '',
                state: '',
                zip: ''
            }
    }
},
    methods: {
        updatePhone() {
            this.phonePartOne = this.phonePartOne.replace(/\D/g, '').slice(0, 3);
            this.phonePartTwo = this.phonePartTwo.replace(/\D/g, '').slice(0, 3);
            this.phonePartThree = this.phonePartThree.replace(/\D/g, '').slice(0, 4);
            this.profileUser.phone = `${this.phonePartOne}${this.phonePartTwo}${this.phonePartThree}`;
        },
        updateHeight() {
            const feet = parseInt(this.heightFeet) || 0;
            const inches = parseInt(this.heightInches) || 0;
            
            if (inches >= 12) {
                this.heightInches = 11;
            }
            
            this.profileUser.height_inch = (feet * 12) + parseInt(this.heightInches);
        },
        initializePhoneParts() {
            if (this.profileUser.phone) {
                this.phonePartOne = this.profileUser.phone.slice(0, 3);
                this.phonePartTwo = this.profileUser.phone.slice(3, 6);
                this.phonePartThree = this.profileUser.phone.slice(6, 10);
            }
        },
        initializeHeightParts() {
            const totalInches = parseInt(this.profileUser.height_inch) || 0;
            this.heightFeet = Math.floor(totalInches / 12);
            this.heightInches = totalInches % 12;
        },
        isSelectedCategory(category) {
            return this.profileUser.preferred_categories.includes(category);
        },
        toggleCategory(category) {
            const index = this.profileUser.preferred_categories.indexOf(category);
            if (index === -1) {
                this.profileUser.preferred_categories.push(category);
            } else {
                this.profileUser.preferred_categories.splice(index, 1);
            }
        },
        async updateDetails() {
            this.clearMessages();
            
            if (!this.validateForm()) {
                return;
            }
            
            try {
                this.updating = true;
                
                const response = await this.$axios.post(`${this.baseUrl}/api/update-profile`, this.profileUser);
                if (response.data.status === 'success') {
                    await this.$store.dispatch('UpdateUserData', this.profileUser);
                    this.showToast('Profile updated successfully!');
                }
            } catch (error) {
                this.errorMessage = error.message || 'Failed to update profile';
                this.showErrorMessage = true;
            } finally {
                this.updating = false;
            }
        },
        async updatePhysicalInfo() {
            this.clearMessages();
            
            try {
                this.updating = true;
                
                const physicalData = {
                    gender: this.profileUser.gender,
                    weight: this.profileUser.weight,
                    height_inch: this.profileUser.height_inch
                };
                
                const response = await this.$axios.post(`${this.baseUrl}/api/update-physical-info`, physicalData);
                if (response.data.status === 'success') {
                    await this.$store.dispatch('UpdateUserData', {...this.profileUser, ...physicalData});
                    this.showToast('Physical information updated successfully!');
                }
            } catch (error) {
                this.physicalInfoErrorMessage = error.message || 'Failed to update physical information';
                this.showPhysicalInfoError = true;
            } finally {
                this.updating = false;
            }
        },
        async updateAddress() {
            this.clearMessages();
            
            try {
                this.updating = true;
                
                const response = await this.$axios.post(`${this.baseUrl}/api/ship-address`, this.addressForm);
                if (response.data.status === 'success') {
                    await this.$store.dispatch('saveShippingDetails', this.addressForm);
                    this.showToast('Address updated successfully!');
                }
            } catch (error) {
                this.addressErrorMessage = error.message || 'Failed to update address';
                this.showAddressError = true;
            } finally {
                this.updating = false;
            }
        },
        async updatePassword() {
            this.clearMessages();
            
            if (this.passwordForm.newPassword !== this.passwordForm.confirmPassword) {
                this.passwordErrorMessage = 'Passwords do not match';
                this.showPasswordError = true;
                return;
            }
            
            try {
                this.updating = true;
                
                const response = await this.$axios.post(`${this.baseUrl}/api/update-password`, this.passwordForm);
                if (response.data.status === 'success') {
                    this.showToast('Password updated successfully!');
                    
                    // Reset password form
                    this.passwordForm = {
                        oldPassword: '',
                        newPassword: '',
                        confirmPassword: ''
                    };
                }
            } catch (error) {
                this.passwordErrorMessage = error.message || 'Failed to update password';
                this.showPasswordError = true;
            } finally {
                this.updating = false;
            }
        },
        clearMessages() {
            this.showSuccessMessage = false;
            this.showErrorMessage = false;
            this.showPhysicalInfoSuccess = false;
            this.showPhysicalInfoError = false;
            this.showAddressSuccess = false;
            this.showAddressError = false;
            this.showPasswordSuccess = false;
            this.showPasswordError = false;
            this.errorMessage = '';
            this.physicalInfoErrorMessage = '';
            this.addressErrorMessage = '';
            this.passwordErrorMessage = '';
        },
        validateForm() {
            // Basic validation
            if (!this.profileUser.first_name || !this.profileUser.last_name) {
                this.errorMessage = 'Please enter your full name';
                this.showErrorMessage = true;
                return false;
            }
            
            if (!this.profileUser.email || !this.validateEmail(this.profileUser.email)) {
                this.errorMessage = 'Please enter a valid email address';
                this.showErrorMessage = true;
                return false;
            }
            
            if (!this.profileUser.phone || this.profileUser.phone.length !== 10) {
                this.errorMessage = 'Please enter a valid 10-digit phone number';
                this.showErrorMessage = true;
                return false;
            }
            
            return true;
        },
        validateEmail(email) {
            const re = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
            return re.test(email);
        },
        async fetchShippingAddress() {
            try {
                const response = await this.$axios.get(`${this.baseUrl}/api/ship-address`);
                
                if (response.data.shipping) {
                    this.addressForm = response.data.shipping;
                    await this.$store.dispatch('saveShippingDetails', response.data.shipping);
                }
            } catch (error) {
                console.error('Failed to fetch shipping address:', error);
            }
        },
        initializeUserData() {
            // Deep copy of user data to avoid direct mutation
            this.profileUser = JSON.parse(JSON.stringify(this.user));
            
            // Initialize phone parts
            this.initializePhoneParts();
            
            // Initialize height parts
            this.initializeHeightParts();
            
            // Ensure categories array exists
            if (!this.profileUser.preferred_categories) {
                this.profileUser.preferred_categories = [];
            }
            
            // Initialize text updates option
            if (typeof this.profileUser.text_updates === 'undefined') {
                this.profileUser.text_updates = false;
            }
        },
        
        showToast(message) {
            this.toastMessage = message;
            this.showT = true;
            // Hide toast after 3 seconds to match the animation
            setTimeout(() => {
                this.showT = false;
            }, 3000);
        }
    },
    created() {
        this.initializeUserData();
        
        // Load shipping address if not in store
        if (!this.$store.getters.shipping) {
            this.fetchShippingAddress();
        } else {
            this.addressForm = this.$store.getters.shipping;
        }
    },
    watch: {
        user: {
            handler(newVal) {
                if (newVal) {
                    this.initializeUserData();
                }
            },
            immediate: true,
            deep: true
        }
    }
}
</script>